import { Route, Routes, MemoryRouter } from 'react-router-dom';
import { Start } from '../../pages/start/Start';
import { BoatTripSearch } from '../../pages/booking/boat-trips/Search';
import { Order } from '../../pages/order/Order';
import { BookingConfirmation } from '../../pages/order/BookingConfirmation';
import { Checkout } from '../../pages/checkout/Checkout';
import { UpcomingBookings } from '../../pages/upcoming/UpcomingBookings';

export interface NavigationProps {
  view: string;
}

export const Navigation = ({ view }: NavigationProps) => {
  // If view is 'upcoming', render a different component structure
  if (view === 'upcoming') {
    return (
      <MemoryRouter>
        <Routes>
          <Route path="/" element={<UpcomingBookings />} />
        </Routes>
      </MemoryRouter>
    );
  }

  // Default booking view
  return (
    <MemoryRouter>
      <Routes>
        <Route path="/" element={<Start />}>
          <Route path=":routeId" element={<BoatTripSearch />} />
        </Route>
        <Route path='checkout/order' element={<Order />} />
        <Route path='checkout/confirmation' element={<BookingConfirmation />} />
        <Route path='checkout/:session' element={<Checkout />} />
      </Routes>
    </MemoryRouter>
  );
}